import React from 'react';
import {serverSideTranslations} from '@app/modules/locale-management/server';
import {TempoLandingPage} from '@app/components/layout/LandingPage';
import type {GetStaticProps} from 'next';
import type {LandingProps} from '@app/types/next';
import {IndexHeroSection} from '@app/views/moments/index/hero';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingSections} from '@tempo/landing';
import {IndexSummerSection} from '@app/views/moments/index/index-summer';
import {IndexWorkoutSection} from '@app/views/moments/index/index-workout';
import {IndexChristmasSection} from '@app/views/moments/index/index-christmas';
import {getFooterLinksPerLang} from '@app/modules/ssg-data/unlogged-data';

const MomentsPage: React.FC<LandingProps> = () => {
	const {t} = useTranslation();
	const pageTitle = t('hubmomentslandingpage_text_seotitle_standalone-web', {
		ns: 'moments',
	});
	const pageDescription = t(
		'hubmomentslandingpage_text_seodescription_standalone-web',
		{ns: 'moments'},
	);

	return (
		<TempoLandingPage title={pageTitle} description={pageDescription}>
			<LandingSections topGutter>
				<IndexHeroSection />
				<IndexSummerSection />
				<IndexWorkoutSection />
				<IndexChristmasSection />
			</LandingSections>
		</TempoLandingPage>
	);
};

export const getStaticProps: GetStaticProps<LandingProps> = async ({
	locale = '',
	locales = [],
}) => {
	const translations = await serverSideTranslations(locale, [
		'moments',
		'common',
	]);
	return {
		props: {
			...translations,
			dehydratedState: {
				...(await getFooterLinksPerLang({locale, locales})),
			},
			tracking: {
				pagecategory: 'moments',
				pagename: 'moments',
				cdpViewId: 'moments',
			},
		},
	};
};

export default MomentsPage;
